import React, { useState, useRef, useEffect } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { 
  ChevronLeft, 
  ChevronRight, 
  Star, 
  MapPin, 
  Award,
  ArrowRight,
  X,
  User,
  Phone,
  MapPinned,
  Milk
} from 'lucide-react';
// import MyButton from '../../../../components/common/Button/MyButton';
import '../../../assets/styles/customer/layout/TopDistributorsSection.css';
import MyButton from '../../../components/common/Button/MyButton';

const TopDistributorsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedDistributor, setSelectedDistributor] = useState(null);
  const autoPlayRef = useRef(null);

  // Form State
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    location: '',
    quantity: ''
  });

  const distributors = [
    {
      id: 1,
      name: 'Ahmad Dairy Farm',
      image: 'https://images.unsplash.com/photo-1563636619-e9143da7973b?w=600&q=80',
      rating: 4.9,
      topRated: true,
      description: 'Premium quality milk delivered fresh to your doorstep every morning',
      location: 'Karachi, Pakistan',
      price: '185',
      deliveries: '1,200+',
      customers: '450+'
    },
    {
      id: 2,
      name: 'Green Valley Milk',
      image: 'https://images.unsplash.com/photo-1628088062854-d1870b4553da?w=600&q=80',
      rating: 4.8,
      topRated: false,
      description: 'Farm-fresh milk from grass-fed cows, delivered daily',
      location: 'Lahore, Pakistan',
      price: '175',
      deliveries: '980+',
      customers: '380+'
    },
    {
      id: 3,
      name: 'Pure Farm Dairy',
      image: 'https://images.unsplash.com/photo-1550583724-b2692b85b150?w=600&q=80',
      rating: 4.9,
      topRated: true,
      description: 'Premium quality milk delivered fresh to your doorstep every morning',
      location: 'Faisalabad, Pakistan',
      price: '180',
      deliveries: '1,500+',
      customers: '520+'
    },
    {
      id: 4,
      name: 'Mountain Fresh',
      image: 'https://images.unsplash.com/photo-1600788907416-456578634209?w=600&q=80',
      rating: 4.7,
      topRated: false,
      description: 'Pure mountain milk from healthy, happy cows',
      location: 'Islamabad, Pakistan',
      price: '190',
      deliveries: '850+',
      customers: '320+'
    },
    {
      id: 5,
      name: 'Heritage Dairy',
      image: 'https://images.unsplash.com/photo-1606312619070-d48b4cca5bf3?w=600&q=80',
      rating: 4.6,
      topRated: false,
      description: 'Traditional dairy farming with modern hygiene standards',
      location: 'Multan, Pakistan',
      price: '170',
      deliveries: '720+',
      customers: '290+'
    }
  ];

  // Auto-play functionality
  useEffect(() => {
    if (isAutoPlaying) {
      autoPlayRef.current = setInterval(() => {
        setActiveIndex((prev) => (prev + 1) % distributors.length);
      }, 4000);
    }

    return () => {
      if (autoPlayRef.current) {
        clearInterval(autoPlayRef.current);
      }
    };
  }, [isAutoPlaying, distributors.length]);

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + distributors.length) % distributors.length);
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % distributors.length);
  };

  const handleDotClick = (index) => {
    setActiveIndex(index);
  };

  const handleCardHover = (isHovering) => {
    setIsAutoPlaying(!isHovering);
  };

  const handleBookNow = (distributor) => {
    setSelectedDistributor(distributor);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedDistributor(null);
    setFormData({
      name: '',
      phone: '',
      location: '',
      quantity: ''
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Booking:', formData, selectedDistributor);
    // Show success message
    alert('Booking request sent successfully!');
    handleCloseModal();
  };

  const getCardPosition = (index) => {
    const diff = index - activeIndex;
    if (diff === 0) return 'active';
    if (diff === 1 || diff === -(distributors.length - 1)) return 'next';
    if (diff === -1 || diff === distributors.length - 1) return 'prev';
    return 'hidden';
  };

  return (
    <section className="top-distributors-section">
      
      {/* Floating Bottles */}
      <div className="distributors-floating-bottles">
        <div className="dist-bottle bottle-1">🥛</div>
        <div className="dist-bottle bottle-2">🥛</div>
        <div className="dist-bottle bottle-3">🥛</div>
        <div className="dist-bottle bottle-4">🥛</div>
      </div>

      {/* Wavy Background */}
      <div className="distributors-wave-bg">
        <svg className="dist-wave wave-top" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="rgba(62, 150, 231, 0.04)" 
            d="M0,160L48,170.7C96,181,192,203,288,197.3C384,192,480,160,576,154.7C672,149,768,171,864,181.3C960,192,1056,192,1152,181.3C1248,171,1344,149,1392,138.7L1440,128L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
          ></path>
        </svg>
        <svg className="dist-wave wave-bottom" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path 
            fill="rgba(76, 175, 80, 0.03)" 
            d="M0,96L48,112C96,128,192,160,288,154.7C384,149,480,107,576,101.3C672,96,768,128,864,138.7C960,149,1056,139,1152,128C1248,117,1344,107,1392,101.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>

      <Container>
        
        {/* Section Header */}
        <div className="distributors-header text-center">
          <div className="distributors-badge">
            <Award size={18} />
            <span>Top Rated Distributors</span>
          </div>
          <h2 className="distributors-title">
            Meet Our <span className="distributors-highlight">Best Distributors</span>
          </h2>
          <p className="distributors-subtitle">
            Premium quality milk from our most trusted and highest-rated distributors
          </p>
        </div>

        {/* Carousel */}
        <div className="distributors-carousel">
          
          {/* Navigation Arrows */}
          <button className="carousel-arrow arrow-left" onClick={handlePrev}>
            <ChevronLeft size={28} />
          </button>
          <button className="carousel-arrow arrow-right" onClick={handleNext}>
            <ChevronRight size={28} />
          </button>

          {/* Cards */}
          <div className="carousel-cards-wrapper">
            {distributors.map((distributor, index) => (
              <div
                key={distributor.id}
                className={`distributor-card ${getCardPosition(index)}`}
                onMouseEnter={() => getCardPosition(index) === 'active' && handleCardHover(true)}
                onMouseLeave={() => handleCardHover(false)}
              >
                {/* Top Rated Badge */}
                {distributor.topRated && (
                  <div className="top-rated-badge">
                    <Award size={16} />
                    <span>TOP RATED</span>
                  </div>
                )}

                {/* Image */}
                <div className="card-image">
                  <img src={distributor.image} alt={distributor.name} />
                  <div className="image-overlay"></div>
                </div>

                {/* Rating Badge */}
                <div className="rating-badge">
                  <Star size={16} fill="#ffc107" color="#ffc107" />
                  <span>{distributor.rating}</span>
                </div>

                {/* Content */}
                <div className="card-content">
                  <h3 className="distributor-name">{distributor.name}</h3>
                  <p className="distributor-description">{distributor.description}</p>
                  
                  <div className="distributor-location">
                    <MapPin size={16} />
                    <span>{distributor.location}</span>
                  </div>

                  <div className="distributor-stats">
                    <div className="stat-item">
                      <Milk size={16} />
                      <span>{distributor.deliveries}</span>
                    </div>
                    <div className="stat-item">
                      <User size={16} />
                      <span>{distributor.customers}</span>
                    </div>
                  </div>

                  <div className="card-footer">
                    <div className="price-tag">
                      <span className="price-label">Rs.</span>
                      <span className="price-amount">{distributor.price}</span>
                      <span className="price-unit">/L</span>
                    </div>
                    <button 
                      className="book-now-btn"
                      onClick={() => handleBookNow(distributor)}
                    >
                      Book Now
                      <ArrowRight size={18} className="ms-1" />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Dots Indicator */}
          <div className="carousel-dots">
            {distributors.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === activeIndex ? 'active' : ''}`}
                onClick={() => handleDotClick(index)}
              />
            ))}
          </div>
        </div>

        {/* View All Button */}
        <div className="distributors-view-all text-center">
          <MyButton variant="primary" className="view-all-btn">
            View All Distributors
            <ArrowRight size={20} className="ms-2" />
          </MyButton>
        </div>

      </Container>

      {/* Booking Modal */}
      <Modal 
        show={showModal} 
        onHide={handleCloseModal}
        centered
        className="booking-modal"
      >
        <div className="modal-custom-content">
          <button className="modal-close-btn" onClick={handleCloseModal}>
            <X size={24} />
          </button>

          <div className="modal-header-custom">
            <div className="modal-distributor-logo">
              🥛
            </div>
            <h3 className="modal-title">Book from {selectedDistributor?.name}</h3>
            <p className="modal-subtitle">
              Fill in your details to request milk delivery from this distributor.
            </p>
            <p className="modal-rate">
              Rate: <span className="rate-highlight">Rs. {selectedDistributor?.price}/Liter</span>
            </p>
          </div>

          <form onSubmit={handleSubmit} className="booking-form">
            <div className="form-group">
              <label className="form-label">
                <User size={18} />
                <span>Your Name</span>
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Enter your full name"
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <Phone size={18} />
                <span>Phone Number</span>
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Enter your phone number"
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <MapPinned size={18} />
                <span>Delivery Location</span>
              </label>
              <input
                type="text"
                name="location"
                value={formData.location}
                onChange={handleInputChange}
                placeholder="Enter your delivery address"
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">
                <Milk size={18} />
                <span>Daily Quantity (Liters)</span>
              </label>
              <input
                type="number"
                name="quantity"
                value={formData.quantity}
                onChange={handleInputChange}
                placeholder="Enter quantity in liters"
                className="form-input"
                min="1"
                step="0.5"
                required
              />
            </div>

            <div className="modal-actions">
              <button 
                type="button" 
                className="cancel-btn"
                onClick={handleCloseModal}
              >
                Cancel
              </button>
              <button type="submit" className="confirm-btn">
                Confirm Booking
              </button>
            </div>
          </form>
        </div>
      </Modal>

    </section>
  );
};

export default TopDistributorsSection;